<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  @if (imageUrl !== null) {
    <pinch-zoom [limit-zoom]=5 overflow="visible">
      <ion-img [src]="imageUrl" alt=""/>
    </pinch-zoom>
  }

</ion-content>
